<template>
  <div class="grid gap-3 grid-cols-1 md:grid-cols-5 mb-7 selected-stage-list">
    <div class="col-span-3">
      <div class="flex">
        <slot name="icon" />
        <div>
          {{ title }}
          <span v-if="subtitle" class="block text-[24px]">{{ subtitle }}</span>
        </div>
      </div>
    </div>
    <div>{{ header ? price : formattedPrice }}</div>
    <div class="text-center col-span-1">{{ tickets }}</div>
  </div>
</template>
<script>
import { moneyFormat } from "@/utils/helper";
import { reactive, toRefs } from "@vue/reactivity";
import { computed } from "@vue/runtime-core";
export default {
  name: "StageGroupList",
  props: {
    header: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    price: {
      type: [String, Number],
      default: null,
    },
    tickets: {
      type: [String, Number],
      default: null,
    },
  },
  setup(props) {
    const state = reactive({
      formattedPrice: computed(() => {
        return moneyFormat(props.price || 0);
      }),
    });

    return {
      ...toRefs(state),
    };
  },
};
</script>
<style lang="scss">
.selected-stage-list {
  img {
    margin-right: 20px;
  }
}
</style>
